import type { Locale } from "@/lib/i18n";
import { en, type SiteCopy } from "./en";
import { es } from "./es";
import { pt } from "./pt";

export type { SiteCopy };

export const COPY = {
  en,
  es,
  pt,
} as const satisfies Record<Locale, SiteCopy>;
